var render = function render(){var _vm=this,_c=_vm._self._c;return _c('f7-page',{attrs:{"name":"notificationsPage"}},[_c('div',{attrs:{"id":"notifications-page"}},[_c('div',{staticClass:"sub-menu-wrapper"},[_c('NotificationsHeader')],1),_vm._v(" "),_c('div',{staticClass:"content-section"},[_c('NotificationsFeed',{attrs:{"notifications":_vm.filteredNotifications}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }